import Box from '@mui/material/Box';
import { ComponentType, useState } from 'react';

import { LoadingWrapper } from 'library/components/controls/loaders/LoadingWrapper';

import { PdfPrintDialogShell } from './PdfPrintDialogShell';
import { PrintPdfDialogContentProps } from './types';
import {
	PdfUserSettingsCategories,
	useGetPdfUserSettings,
} from './usePdfUserSettings';

export type PrintPdfDialogProps<T, K> = {
	ContentComponent: ComponentType<PrintPdfDialogContentProps<T> & K>;
	contentProps?: K;
	id: number;
	isOpen: boolean;
	mapRecordToPdfUserSettings: (
		dict?: Record<string, boolean>
	) => T | undefined;
	onClose: () => void;
	pdfSettingsCategories: PdfUserSettingsCategories;
	previewDebounce?: number;
	title: string;
};

export const PrintPdfDialog = <T, K>({
	ContentComponent,
	contentProps = {} as K,
	id,
	isOpen,
	mapRecordToPdfUserSettings,
	onClose,
	pdfSettingsCategories,
	previewDebounce,
	title,
}: PrintPdfDialogProps<T, K>) => {
	const [isDealer, setIsDealer] = useState(true);
	const [isPreview, setIsPreview] = useState(false);

	const { isLoading, settings } = useGetPdfUserSettings(
		pdfSettingsCategories,
		mapRecordToPdfUserSettings
	);
	const key = isDealer ? 'dealer' : 'customer';

	return (
		<PdfPrintDialogShell
			isOpen={isOpen}
			onClose={onClose}
			title={title}
			fullWidth={isPreview}>
			<LoadingWrapper loading={isLoading}>
				<Box data-testid={key}>
					<ContentComponent
						id={id}
						onClose={onClose}
						key={key}
						defaultPdfSettings={settings}
						isDealer={isDealer}
						setIsDealer={setIsDealer}
						isPreview={isPreview}
						setIsPreview={setIsPreview}
						previewDebounce={previewDebounce}
						{...contentProps}
					/>
				</Box>
			</LoadingWrapper>
		</PdfPrintDialogShell>
	);
};
